// api/notificationApi.js
import { fetchApi } from "../utils/apiUtils";

export const fetchNotificationsApi = async (page = 1, searchTerm, instanceId) => {
  const query = new URLSearchParams();

  if (page) query.append("page", page);
  if (searchTerm) query.append("title", searchTerm);
  if (instanceId) query.append("notification_id", instanceId);

  return fetchApi(`notification-read-list/?${query.toString()}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const fetchUnreadNotificationsApi = async (page = 1) => {
  return fetchApi(`notification-read-list/?read=false&page=${page}`, {
    method: "GET",
    requiresAuth: true
  });
};

export const markNotificationsAsReadApi = async (notificationIds) => {
  return fetchApi('notification-bulk-mark-read/', {
    method: 'POST',
    requiresAuth: true,
    body: { notification_ids: notificationIds }
  });
};

export const markNotificationsAsUnreadApi = async (notificationIds) => {
  return fetchApi('notification-bulk-mark-unread/', {
    method: 'POST',
    requiresAuth: true,
    body: { notification_ids: notificationIds }
  });
};

export const deleteNotificationsApi = async (notificationIds) => {
  return fetchApi('notification-bulk-delete/', {
    method: 'POST',
    requiresAuth: true,
    body: { notification_ids: notificationIds }
  });
};